var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-icon-info-circle',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.showModal}}),_c('b-modal',{attrs:{"id":_vm.uuid,"centered":"","title":"Help","ok-only":""}},[_c('p',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.message))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }